var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-navigation"},_vm._l((_vm.navigation),function(item){return _c('v-btn',{key:item.value,staticClass:"tw-font-normal",class:{ 'tw-text-primary': _vm.activePage === item.value},attrs:{"text":"","small":""},on:{"click":function($event){return _vm.$router.push({name: item.url})}}},[_vm._v(" "+_vm._s(item.value)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }